@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.StatusButton {
  @extend %font-family-primary;

  display: flex;
  font-size: $font-size-normal;
  color: $theme-color-text;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  &:active {
    outline: none;
  }

  .contentWrapper {
    display: grid;
    grid-template-columns: auto auto auto;
    column-gap: 0.5em;
  }
}
